import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import scrollTo from 'simple-scrollTo';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/todo-page/dependencies';

Component('tr-todo-page-dependencies', {
  mixins: [eventListenerMixin],

  properties: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  connected() {
    this.listenTo(this, {
      click: this.handleClick.bind(this),
      'tr-grid-dependency-row:click': (event) => {
        const { detailUrl } = event.target;
        window.open(detailUrl);
      },
    });
  },

  handleClick(event) {
    if (!closest(event.target, '.cancel-button', this)) return;
    const form = this.querySelector('form');
    if (form) form.remove();
  },

  focus() {
    setTimeout(() => {
      const field = this.querySelector('.todos_dependency_todo_id tr-combo-select-field');
      if (field) field.handleResultActive();
    });
  },

  scrollTo() {
    const target = this.querySelector('form') || this;
    let container = closest(this, '.page__content');
    if (!container) container = 'body, html';

    scrollTo({
      target: $(target),
      container: $(container),
      animation: false,
      offset: { y: 84, x: 0 },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
